import React, { type PropsWithChildren, useEffect, useState } from 'react';

import { IntlProvider, useIntl } from 'react-intl-next';

import lazyMessages from '../../i18n/lazy';

export const AccountMenuIntlProvider = ({ children }: PropsWithChildren<{}>) => {
	const { locale } = useIntl();
	const messages = useMessages(locale);

	return (
		<IntlProvider locale={locale} messages={messages}>
			{children}
		</IntlProvider>
	);
};

const useMessages = (locale: string) => {
	const [messages, setMessages] = useState<Record<string, string>>();

	useEffect(() => {
		if (/^en(-US)?$/i.exec(locale)) {
			// Use fallback messages, which are already US English
			setMessages(undefined);
		} else {
			let cancelled = false;

			loadMessages(locale)
				.catch((_error) => undefined) // TODO: Log error somehow (analytics?)
				.then((messages) => {
					if (!cancelled) {
						setMessages(messages);
					}
				});

			return () => {
				cancelled = true;
			};
		}
	}, [locale, setMessages]);

	return messages;
};

const loadMessages = async (locale: string): Promise<Record<string, string> | undefined> => {
	let [language, region = ''] = locale.split('-', 2);
	language = language.toLowerCase();
	region = region.toUpperCase();

	return (await (lazyMessages[`${language}_${region}`] || lazyMessages[language])?.())?.default;
};
